<div id="breadcrumb-navigation" class="breadcrumb">
  {{ labels.administration }}
  <a
    id="tipos-contrato-breadcrumb-link"
    class="breadcrumb-link selected"
    [routerLink]="['/wapi/admin/tipos-contrato']"
  >
    &nbsp;>&nbsp;{{ labels.tiposContrato }}
  </a>
</div>

<br /><br />

<div id="tipos-contrato-main-container" class="container">
  <mat-card id="tipos-contrato-card">
    <div id="tipos-contrato-header" class="header-options">
      <div id="tipos-contrato-title" class="title">
        <div class="title-wrapper">
          <h1 class="main-title">{{ labels.tiposContrato }}</h1>
        </div>
      </div>
      <div class="header-actions">
        <button
          mat-raised-button
          class="filter-button"
          (click)="toggleSearch()"
          matTooltip="Filtro"
        >
          <mat-icon>filter_list</mat-icon>
          FILTRO
        </button>
        <button
          mat-raised-button
          color="primary"
          class="create-button"
          (click)="openCreateModal()"
          matTooltip="{{ labels.createTipoContrato }}"
        >
          <mat-icon>add</mat-icon>
          {{ labels.createTipoContrato }}
        </button>
      </div>
    </div>

    <!-- Search Panel -->
    @if (showSearchPanel) {
      <div class="search-panel">
        <div class="filters-grid">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar tipos de contrato</mat-label>
            <input
              matInput
              [(ngModel)]="searchQuery"
              (input)="searchTiposContrato($any($event.target).value)"
              placeholder="Buscar por nombre..."
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <!-- Column filters -->
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.nombre"
              (input)="onColumnFilterChange('nombre', $any($event.target).value)"
              placeholder="Filtrar por nombre..."
            />
          </mat-form-field>
        </div>
        <button
          mat-stroked-button
          color="primary"
          (click)="resetFilters()"
          style="height: 40px; align-self: center"
        >
          <mat-icon style="margin-right: 6px">filter_alt_off</mat-icon>
          Limpiar filtros
        </button>
      </div>
    }

    <div id="tipos-contrato-table-section" class="table-container">
      @if (loading$ | async) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>{{ labels.loadingTiposContrato }}</p>
        </div>
      } @else if (error$ | async) {
        <div class="error-container">
          <p class="error-message">{{ error$ | async }}</p>
        </div>
      } @else {
        <div class="table-wrapper">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
            <!-- ID Column -->
            <ng-container matColumnDef="tipoContratoId">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableId }}</th>
              <td mat-cell *matCellDef="let tipoContrato">
                {{ tipoContrato.tipoContratoId }}
              </td>
            </ng-container>

            <!-- Nombre Column -->
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableNombre }}</th>
              <td mat-cell *matCellDef="let tipoContrato">
                {{ tipoContrato.nombre }}
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableActions }}</th>
              <td mat-cell *matCellDef="let tipoContrato">
                <div class="action-buttons">
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="openCreateModal(tipoContrato)"
                    matTooltip="{{ labels.tooltipEdit }}"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    color="warn"
                    (click)="selectTipoContrato(tipoContrato); deleteTipoContrato()"
                    matTooltip="{{ labels.tooltipDelete }}"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [class.selected-row]="selectedTipoContrato?.tipoContratoId === row.tipoContratoId"
            ></tr>
          </table>

          @if (dataSource.data.length === 0) {
            <div class="no-data-container">
              <mat-icon class="no-data-icon">inbox</mat-icon>
              <p class="no-data-message">No hay tipos de contrato disponibles</p>
              <p class="no-data-submessage">
                Haga clic en "Crear Tipo Contrato" para agregar el primero
              </p>
            </div>
          }

          <mat-paginator
            #paginator
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange()"
            aria-label="Seleccionar página de tipos de contrato"
          ></mat-paginator>
        </div>
      }
    </div>
  </mat-card>
</div>

<!-- Create/Edit Modal -->
<ng-template #createTipoContratoModal>
  <h2 id="tipo-contrato-modal-title" mat-dialog-title>
    {{ isEditing ? labels.editTipoContrato : labels.createTipoContrato }}
  </h2>

  <mat-dialog-content id="tipo-contrato-modal-content" class="modal-content">
    <form id="tipo-contrato-form" [formGroup]="tipoContratoForm">
      <!-- ID Field removed in edit to avoid showing a locked, non-editable input -->

      <!-- Nombre Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.nombre }}</mat-label>
        <input
          matInput
          formControlName="nombre"
          placeholder="Ingrese el nombre del tipo de contrato"
          maxlength="100"
          [class.error-field]="hasError('nombre')"
        />
        @if (hasError('nombre')) {
          <mat-error>{{ getErrorMessage('nombre') }}</mat-error>
        }
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions id="tipo-contrato-modal-actions" align="end">
    <button
      id="save-tipo-contrato-button"
      mat-button
      mat-raised-button
      color="primary"
      (click)="saveTipoContrato()"
      [disabled]="tipoContratoForm.invalid"
    >
      <mat-icon>save</mat-icon>
      {{ labels.save }}
    </button>
    <button id="cancel-tipo-contrato-button" mat-button (click)="closeModal()">
      {{ labels.cancel }}
    </button>
  </mat-dialog-actions>
</ng-template>
